<template>
  <div class="skill-dive-section">
    <h1 v-if="showHeader" class="skill-dive-section__title">Skill Dive</h1>
    <template v-if="!userHasSkillDive">
      <div v-if="showHeader" class="skill-dive-section__intro">
        An immersive lab experience featuring thousands of hands-on labs.
      </div>
      <div class="skill-dive-section__plans">
        <PlanSkillDiveItemCard />
      </div>
    </template>
    <template v-else>
      <div class="skill-dive-section__subscribed">
        <div class="skill-dive-section__subscribed-title">You have Skill Dive</div>
        <div class="skill-dive-section__subscribed-subtitle">
          {{ subtitle }}
        </div>
        <div class="skill-dive-section__subscribed-cta">
          <a
            :href="profileSubscriptionsUrl"
            class="btn btn--primary"
            :disabled="hasSkillDiveFullLearningAreas"
          >
            Manage Skill Dive
          </a>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import PlanSkillDiveItemCard from '@/components/plan-item-card/PlanSkillDiveItemCard.vue'

export default {
  name: 'SkillDiveSection',
  components: {
    PlanSkillDiveItemCard,
  },
  props: {
    showHeader: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState({
      isAuthenticated: state => state.auth.isAuthenticated,
    }),
    ...mapGetters({
      userHasSkillDive: 'subscriptions/userHasSkillDive',
      hasSkillDiveFullLearningAreas: 'subscriptions/hasSkillDiveFullLearningAreas',
    }),
    profileSubscriptionsUrl() {
      return `//${process.env.VUE_APP_STREAMING_URL}/dashboard/subscriptions`
    },
    subtitle() {
      if (this.hasSkillDiveFullLearningAreas)
        return 'You have access to all Skill Dive learning areas.'
      return 'Visit my.ine.com to add learning areas'
    },
  },
  async created() {
    if (this.isAuthenticated) {
      await this.getSubscriptionsWithPasses()
    }
  },
  methods: {
    ...mapActions({
      getSubscriptionsWithPasses: 'subscriptions/getSubscriptionsWithPasses',
    }),
  },
}
</script>

<style lang="scss" scoped>
.skill-dive-section {
  margin-bottom: 60px;
  &__title {
    font-size: rem(24px);
    line-height: rem(32px);
    font-style: normal;
    font-weight: 700;
    margin-bottom: 30px;
  }
  &__intro {
    color: var(--light-blue-gray);
    font-size: rem(18px);
    font-style: normal;
    font-weight: 450;
    line-height: rem(24px);
    margin-bottom: 50px;
  }
  &__subscribed {
    padding: 40px;
    background: var(--mid-gray-gradient);
    border-radius: 10px;
    color: var(--white);
    font-family: var(--font-regular);
    display: flex;
    justify-content: center;
    flex-flow: column;
    align-items: center;
    margin-bottom: 60px;
    &-title {
      font-weight: 700;
      font-size: 32px;
      line-height: 38px;
      margin-bottom: 10px;
      text-align: center;
    }
    &-subtitle {
      font-weight: 450;
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 30px;
      color: var(--dusty-gray);
    }
    &-cta {
      .btn {
        text-decoration: none;
      }
    }
  }
}
</style>
